(ns minorodata.components.file-ingest.core
  (:require [minorodata.app.handlers :refer [dispatch dispatch-sync]]
            [minorodata.components.file-ingest.column-select :refer [column-select]]
            [minorodata.components.file-ingest.confirmation :refer [confirmation]]
            [minorodata.components.file-ingest.file-upload :refer [file-upload]]
            [minorodata.components.file-ingest.preview-data :refer [preview-data]]
            [minorodata.components.file-ingest.sheet-select :refer [sheet-selection]]
            [minorodata.components.file-ingest.table-select :refer [table-select]]
            [minorodata.file-ingest.model :as fi.model]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]
            [ui.page :refer [page-content page-controls page-header page-root
                             page-title]]
            [ui.stepper :as stepper]
            [ui.typography :as typography]
            [ui.utils :refer [clsx]]))


(defn go-to-wizard-step [step]
  (dispatch [:file-ingest.events/set-wizard-step step]))

(def step-order (mapv :step fi.model/wizard-steps))

(def skip-conditions
  {:select-sheet  #(<= (count (:sheet-names %)) 1)
   :column-select #(= :existing (:ingest-type %))})

(defn- skipped? [step]
  (when-let [condition (skip-conditions step)]
    (fn [{:keys [current-step] :as ctx}]
      (and (> (.indexOf step-order current-step) (.indexOf step-order step))
           (condition ctx)))))

(def wizard-steps
  (mapv (fn [{:keys [step title]}]
          {:key step :label title :skipped? (skipped? step)})
        fi.model/wizard-steps))

(defn ingest-wizard [{:keys [current-step ctx importing?]}]
  (let [title           (:ingest-step/page-title current-step)
        current-step-id (:ingest-step/step current-step)
        upload-step?    (= current-step-id :upload-file)]
    [page-root
     [page-header {:variant       :border
                   :content-props {:class "pb-0"}}
      [page-title "File ingest"]
      [page-controls
       [stepper/stepper-root {:steps           wizard-steps
                              :ctx             ctx
                              :value           current-step-id
                              :on-value-change go-to-wizard-step}
        [:div {:class "overflow-x-auto scrollbar-thin"}
         [stepper/stepper-list {:navigable? (not importing?)
                                :class      "border-b-transparent *:shrink-0 *:px-3 *:text-sm *:enabled:border-transparent *:enabled:hover:border-transparent"
                                :data-cy    #(str "file-ingest-step-" (name %))}]]]]]

     [page-content {:variant :border}
      [:div {:class "h-full overflow-auto"}
       [:div {:class "p-6"}
        [:div {:class (clsx "mb-6" (when upload-step? "max-w-2xl mx-auto text-center"))}
         [typography/h2 title]
         (when upload-step?
           [typography/p {:class "mt-1 text-kleene-text-secondary"}
            "Import data from a CSV or Excel file."])]

        (case current-step-id
          :upload-file   [:f> file-upload]
          :select-sheet  [sheet-selection]
          :table-select  [table-select]
          :preview-data  [preview-data]
          :column-select [column-select]
          :confirmation  [confirmation]
          nil)]]]]))


(defn file-ingest-page []
  (reagent/create-class
   {:display-name
    "file-ingest-page"

    :constructor
    (fn []
      (dispatch [:ingest-step/add {}])
      (go-to-wizard-step :upload-file))

    :component-will-unmount
    (fn []
      (dispatch-sync [:ingest-step/delete]))

    :render
    (fn []
      (let [current-step @(re-posh/subscribe [:ingest-step/pull])
            ingest-file  @(re-posh/subscribe [:ingest-file/pull])
            ingest-type  (:ingest-table-params/type @(re-posh/subscribe [:ingest-table-params/pull]))
            importing?   @(re-frame/subscribe [:mold-http/loading? :file-ingest.api/import-data])]
        [ingest-wizard
         {:current-step current-step
          :importing?   importing?
          :ctx          {:current-step (:ingest-step/step current-step)
                         :sheet-names  (:ingest-file/sheet-names ingest-file)
                         :ingest-type  ingest-type}}]))}))
